<template>
  <Layout>
    <div class="row justify-content-center">
      <div class="col-md-8 col-lg-6 col-xl-5">
        <div class="card overflow-hidden">
          <div class="bg-soft-primary">
            <div class="row">
              <div class="col-7">
                <div class="text-primary p-4">
                  <h5 class="text-primary">Welcome Back !</h5>
                  <p>Sign in to continue.</p>
                </div>
              </div>
              <div class="col-5 align-self-end">
                <img
                  src="@/assets/images/profile-img.png"
                  alt
                  class="img-fluid"
                />
              </div>
            </div>
          </div>
          <div class="card-body pt-0">
            <div>
              <router-link tag="a" to="/">
                <div class="avatar-md profile-user-wid mb-4">
                  <span class="avatar-title rounded-circle bg-light">
                    <img src="@/assets/images/icon.png" alt height="34" />
                  </span>
                </div>
              </router-link>
            </div>
            <b-alert
              v-model="isAuthError"
              variant="danger"
              class="mt-3"
              dismissible
              >{{ authError }}</b-alert
            >

            <div
              v-if="notification.message"
              :class="'alert ' + notification.type"
            >
              {{ notification.message }}
            </div>

            <b-form class="p-2" @submit.prevent="tryToLogIn">
              <b-form-group
                id="input-group-1"
                label="Email"
                label-for="input-1"
              >
                <b-form-input
                  id="input-1"
                  v-model.trim="email"
                  type="text"
                  placeholder="Enter email"
                  :class="{ 'is-invalid': submitted && $v.email.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && $v.email.$error"
                  class="invalid-feedback"
                >
                  <span v-if="!$v.email.required">Email is required.</span>
                  <span v-if="!$v.email.email">Please enter valid email.</span>
                </div>
              </b-form-group>

              <b-form-group
                id="input-group-2"
                label="Password"
                label-for="input-2"
              >
                <b-form-input
                  id="input-2"
                  v-model="password"
                  type="password"
                  placeholder="Enter password"
                  :class="{ 'is-invalid': submitted && $v.password.$error }"
                ></b-form-input>
                <div
                  v-if="submitted && !$v.password.required"
                  class="invalid-feedback"
                >
                  Password is required.
                </div>
              </b-form-group>
              <div class="custom-control custom-checkbox">
                <input
                  id="customControlInline"
                  type="checkbox"
                  class="custom-control-input"
                />
                <label class="custom-control-label" for="customControlInline"
                  >Remember me</label
                >
              </div>
              <div class="mt-3">
                <b-button type="submit" variant="primary" class="btn-block"
                  >Log In</b-button
                >
              </div>
              <!-- <div class="mt-4 text-center">
                <router-link tag="a" to="/forgot-password" class="text-muted">
                  <i class="mdi mdi-lock mr-1"></i> Forgot your password?
                </router-link>
              </div> -->
            </b-form>
          </div>
          <!-- end card-body -->
        </div>
        <!-- end card -->

        <div class="mt-5 text-center">
          <!-- <p>
            Don't have an account ?
            <router-link tag="a" to="/register" class="font-weight-medium text-primary">Signup now</router-link>
          </p> -->
          <p>
            © {{ new Date().getFullYear() }} Kali -- Developed by CE Solutions
          </p>
        </div>
        <!-- end row -->
      </div>
      <!-- end col -->
    </div>
    <!-- end row -->
  </Layout>
</template>

<style lang="scss" module></style>

<script>
import Layout from '../../../layouts/auth';
import { authMethods, notificationMethods } from '@/state/helpers';
import firebase from 'firebase';
// import { mapState } from "vuex";

import appConfig from '@/app.config';
import { required, email } from 'vuelidate/lib/validators';

/**
 * Login component
 */
export default {
  page: {
    title: 'Login',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout },
  data() {
    return {
      email: null,
      password: null,
      submitted: false,
      authError: null,
      tryingToLogIn: false,
      isAuthError: false,
    };
  },
  validations: {
    email: { required, email },
    password: { required },
  },
  computed: {
    // ...mapState("authfack", ["status"]),
    notification() {
      return this.$store ? this.$store.state.notification : null;
    },
  },
  methods: {
    ...authMethods,
    ...notificationMethods,
    // Try to log the user in with the username
    // and password they provided.
    tryToLogIn() {
      this.submitted = true;
      // stop here if form is invalid
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      } else {
        if (process.env.VUE_APP_DEFAULT_AUTH === 'firebase') {
          this.tryingToLogIn = true;
          // Reset the authError if it existed.
          this.authError = null;
          return (
            this.logIn({
              email: this.email,
              password: this.password,
            })
              // eslint-disable-next-line no-unused-vars
              .then(async (token) => {
                //get the sage integration keys, if the company has an integration
                this.tryingToLogIn = false;
                this.isAuthError = false;
                //check to see if the user has access to the admin panel.
                // await this.getAuthenticatedUsersAdminLevel(token);
                if (this.$store.state.auth.userRoles) {
                  this.checkUserLevel();
                } else {
                  await this.getAuthenticatedUsersAdminLevel(token);
                  this.checkUserLevel();
                }
              })
              .catch((error) => {
                this.tryingToLogIn = false;
                this.authError = error ? error : '';
                this.isAuthError = true;
              })
          );
        }
      }
    },
    /**
     * Gets the user's admin level.
     */
    async getAuthenticatedUsersAdminLevel(user) {
      if (!user) {
        return null;
      } else {
        //get the company name from the database as well.
        let userLevels;
        await firebase
          .firestore()
          .collection('employees')
          .where('auth', '==', user.uid)
          .get()
          .then((querySnapshot) => {
            if (!querySnapshot.empty) {
              querySnapshot.forEach((user) => {
                userLevels = user.data().position;
                this.updateUserAuthAccess({ userLevels }); //this function is in the auth.js file.
              });
            }
          })
          .catch((err) => {
            console.log(`Error getting user data: ${err}`);
          });
      }
    },
    checkUserLevel: function() {
      //if the user logging in is not an admin, but they are a mechanic, send them to the work order page.
      if (this.$store.state.auth.userRoles.includes('Admin')) {
        // Redirect to the originally requested page, or to the home page
        this.$router.push(
          this.$route.query.redirectFrom || { name: 'default' }
        );
      } else if (this.$store.state.auth.userRoles.includes('Supervisor')) {
        this.$router.push(
          this.$route.query.redirectFrom || { name: 'default' }
        );
      } else if (this.$store.state.auth.userRoles.includes('Mechanic')) {
        // Redirect to the originally requested page, or to the home page
        this.$router.push({ name: 'workOrders' });
      } else {
        this.tryingToLogIn = false;
        this.authError = 'Access denied';
        this.isAuthError = true;
      }
    },
  },
  created() {
    //watch for auth state changes. If the state chages, sent the value to the store.
    //if the change was that we are logged in, then send the user to the dashboard page automatically.
    firebase.auth().onAuthStateChanged(async (user) => {
      //go get the auth level of the user and see if they have access to the admin panel, if the account is already logged in.
      this.updateUserAuthState({ user });
      if (user) {
        if (this.$route.query.redirectFromName == 'documentsReport') {
          this.$router.push({
            name: 'documentsReport',
            query: this.$route.query,
          });
        } else {
          // this.$router.push({ name: 'home' });
          //if the role doesn't include admin, then we don't send them to the homepage.
          if (this.$store.state.auth.userRoles.includes('Admin')) {
            this.$router.push({ name: 'home' });
          } else if (this.$store.state.auth.userRoles.includes('Supervisor')) {
            this.$router.push({ name: 'home' });
          } else if (this.$store.state.auth.userRoles.includes('Mechanic')) {
            this.$router.push({ name: 'workOrders' });
          }
        }
      }
    });
  },
};
</script>
